import { Action, Reducer } from "redux";
import { AppThunkAction, remoteActions } from ".";

export const YOUNG_DRIVER_CHANGED = "YOUNG_DRIVER_CHANGED";
export const YOUNG_DRIVER_INVALID = "YOUNG_DRIVER_INVALID";
export const YOUNG_DRIVER_VALID = "YOUNG_DRIVER_VALID";

export interface YoungDriverValue {
  value: boolean;
  text: string;
}

export interface YoungDriverState {
  title: string;
  /**
   * TRUE means customer has less then 25/23 years!
   */
  selected?: boolean;
  questionVisible: boolean;
  values: YoungDriverValue[];
  description?: { title: string; text: string };
  requiredErrorMessage?: string;
  showError: boolean;
}

// for dev. purposes
export const defaults: YoungDriverState = {
  // localize;
  title: "Är någon förare under 25 år?",
  questionVisible: true,
  selected: undefined,
  values: [
    {
      value: true,
      text: "Ja",
    },
    {
      value: false,
      text: "Nej",
    },
  ],
  requiredErrorMessage: "Vi behöver veta om du kört skadefritt eller inte.",
  showError: false,
};

export type YoungDriverAction = {
  type: typeof YOUNG_DRIVER_CHANGED | typeof YOUNG_DRIVER_INVALID | typeof YOUNG_DRIVER_VALID;
  payload: { value: boolean | undefined };
};

export const reducer: Reducer<YoungDriverState> = (state: YoungDriverState = defaults, input: Action): YoungDriverState => {
  const action = input as YoungDriverAction;

  switch (action?.type) {
    case YOUNG_DRIVER_CHANGED:
      const newValue = action.payload.value;
      if (newValue == null) {
        return state;
      }
      return { ...state, selected: newValue, showError: false };
    case YOUNG_DRIVER_INVALID: {
      return {
        ...state,
        showError: true,
      };
    }

    case YOUNG_DRIVER_VALID: {
      return {
        ...state,
        showError: false,
      };
    }

    default:
      return state;
  }
};

export const actions = {
  youngDriverChanged:
    (value: unknown): AppThunkAction<YoungDriverAction | AppThunkAction<{}>> =>
    dispatch => {
      dispatch({
        type: YOUNG_DRIVER_CHANGED,
        payload: { value: value as boolean },
      });

      dispatch(remoteActions.requestPriceData());
    },
};
